import type { IsoDate } from '@omnipresentgroup/design-system';
import { DateTime } from 'luxon';

export const isOverdueDate = (dueDate: IsoDate) =>
  DateTime.now().toMillis() > DateTime.fromISO(dueDate).toMillis();

export const getOverdueDays = (dueDate: IsoDate) => {
  return Math.floor(
    Math.abs(DateTime.fromISO(dueDate).diffNow('days').as('days')),
  );
};
